import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Camera, Shield, ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function SellerLanding() {
  const { t } = useI18n();
  const steps = [
    t("seller.step1"), t("seller.step2"), t("seller.step3"), t("seller.step4"),
    t("seller.step5"), t("seller.step6"), t("seller.step7"), t("seller.step8"),
  ];
  return (
    <div>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16">
        <p className="text-xs font-bold uppercase tracking-widest text-[color:var(--wv-green-dark)]">{t("seller.kicker")}</p>
        <h1 className="font-display mt-2 text-4xl md:text-5xl font-extrabold text-[color:var(--wv-obsidian)] leading-tight max-w-3xl" data-testid="seller-hero-title">
          {t("seller.title")}
        </h1>
        <p className="mt-4 text-lg text-slate-600 max-w-2xl">"{t("hero.tag_seller")}"</p>
        <div className="mt-6 p-5 rounded-2xl bg-[color:var(--wv-sand)] border border-slate-200 max-w-3xl">
          <div className="flex items-start gap-3">
            <Shield className="w-5 h-5 text-[color:var(--wv-green)] mt-0.5 flex-shrink-0" />
            <p className="text-sm text-slate-700 leading-relaxed"><strong>{t("seller.notice")}</strong></p>
          </div>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/woning-aanmelden" className="wv-btn-primary inline-flex items-center gap-2" data-testid="seller-landing-cta">
            {t("cta.submit_property")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      <section className="bg-white py-16 border-t border-slate-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
          <h2 className="font-display text-3xl font-bold text-[color:var(--wv-obsidian)]">{t("seller.how_title")}</h2>
          <ol className="mt-8 grid md:grid-cols-2 gap-5">
            {steps.map((step, i) => (
              <li key={i} className="flex gap-3 p-4 rounded-xl border border-slate-200">
                <div className="w-8 h-8 rounded-lg bg-[color:var(--wv-navy)] text-white font-bold grid place-items-center font-mono-num">{i + 1}</div>
                <p className="text-slate-700 mt-1">{step}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="bg-[color:var(--wv-sand)] py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 grid md:grid-cols-2 gap-10">
          <div className="p-6 rounded-2xl bg-white border border-slate-200">
            <Camera className="w-8 h-8 text-[color:var(--wv-green)]" />
            <h3 className="font-display mt-3 text-2xl font-bold">{t("seller.photo_title")}</h3>
            <p className="mt-2 text-slate-600">{t("seller.photo_desc")}</p>
            <Link to="/fotografie" className="mt-4 inline-flex wv-btn-green text-sm" data-testid="seller-landing-photo-cta">{t("seller.photo_cta")}</Link>
          </div>
          <div className="p-6 rounded-2xl bg-white border border-slate-200">
            <CheckCircle2 className="w-8 h-8 text-[color:var(--wv-green)]" />
            <h3 className="font-display mt-3 text-2xl font-bold">{t("seller.own_photo_title")}</h3>
            <p className="mt-2 text-slate-600">{t("seller.own_photo_desc")}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
